var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecoricon02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 76,
    viewBox: "0 0 109 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.4336 71.6328C57.9916 75.0321 32.1693 70.5212 3.38672 37.2705C3.575 37.0881 3.77913 36.8909 4.00098 36.6826C5.43717 35.3343 7.56499 33.4791 10.2988 31.4844C15.7787 27.4861 23.6221 22.9796 33.1689 20.8135C42.6773 18.6561 53.9331 18.8042 66.3574 24.1719C78.4159 29.3816 91.7226 39.5736 105.629 57.6465C105.482 57.7728 105.324 57.9055 105.158 58.0449C103.762 59.2161 101.687 60.827 99.0098 62.5518C93.6474 66.0069 85.9233 69.8836 76.4336 71.6328Z",
    fill: "#0072A3",
    stroke: "#18466F",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6306 40.8469C51.3137 34.81 58.6921 32.1268 64.729 34.8099C70.7659 37.493 73.4491 44.8715 70.766 50.9084C68.0829 56.9453 60.7044 59.6284 54.6675 56.9453C48.6306 54.2622 45.9475 46.8838 48.6306 40.8469Z",
    stroke: "#F1ECE2",
    strokeWidth: 4.02462,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7905 64.9941L67.7475 54.9326",
    stroke: "#F1ECE2",
    strokeWidth: 4.02462,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40 2.0127L47 21.0127",
    stroke: "#18466F",
    strokeWidth: 4.02462,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3569 57.9512L57.6862 68.6836",
    stroke: "#F1ECE2",
    strokeWidth: 4.02462,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61 24.0127L62 4.0127",
    stroke: "#18466F",
    strokeWidth: 4.02462,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2646 63.6528L50.6431 53.9267",
    stroke: "#F1ECE2",
    strokeWidth: 4.02462,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81 9.0127L74 27.0127",
    stroke: "#18466F",
    strokeWidth: 4.02462,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5386 52.5854L47.6248 46.2131",
    stroke: "#F1ECE2",
    strokeWidth: 4.02462,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8648 20.2021L80.1352 29.824",
    stroke: "#18466F",
    strokeWidth: 4.02462,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4368 48.5605L47.9598 42.5237",
    stroke: "#F1ECE2",
    strokeWidth: 4.02462,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoricon02);
export default __webpack_public_path__ + "static/media/decoricon02.8c3cd0b5125b0f7a4feba6b3378fb3dd.svg";
export { ForwardRef as ReactComponent };